/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { addScenario,setInputs } from '@redux/actions/FinancialModelActions';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  formControl: {
    marginRight: 50,
    minWidth: 220
  },
  select: {
    '& .MuiList-root': {
      height: 'auto !important'
    },
    '& .MuiPaper-rounded': {
      maxHeight: '200px !important'
    }
  },
  or: {
    textAlign: 'center'
  },
  loader: {}
}));

const SelectComponent = ({ selectScenario }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [source, setSource] = useState('');
  const [scenarios, setScenarios] = useState([]);
  const [newScenario, setNewScenario] = useState('');
  const [scenario, setScenario] = useState({});

  const datasources = useSelector(
    (state) => state.FinancialModelReducer.datasources
  );
  const dispatch = useDispatch();

  // const getDatasources = async () => {
  //   try {
  //     setIsLoading(true);
  //     const {
  //       data: { data }
  //     } = await axios.get('http://drivee.localhost/api/fmodel/diy/');
  //     setDatasources(data);
  //     setIsLoading(false);
  //     return data;
  //   } catch (error) {
  //     setIsLoading(false);
  //     console.log('ERROOORRR', error);
  //   }
  // };

  const getScenarios = async (id) => {
    try {
      setIsLoading(true);
      const {
        data: { data }
      } = await axios.get(
        `http://drivee.localhost/api/fmodel/scenarios/diy/${id}`
      );
      setScenarios(data);
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
      console.log('ERROOORRR', error);
    }
  };

  // const createScenario = async () => {
  //   try {
  //     setIsLoading(true);
  //     const {
  //       data: { data }
  //     } = await axios.post('http://drivee.localhost/api/fmodel/scenarios', {
  //       name: newScenario,
  //       data_source_id: source
  //     });
  //     setIsLoading(false);

  //     return data;
  //   } catch (error) {
  //     setIsLoading(false);
  //     console.log('ERROOORRR', error);
  //   }
  // };

  // useEffect(() => {
  //   getDatasources();
  // }, []);

  const handleChangeSource = (e) => {
    setSource(e.target.value);
    getScenarios(e.target.value);
  };

  const handleChangeScenario = ({ target: { value } }) => {
    if (value) {
      setScenario(value);
      selectScenario(scenarios.filter((scen) => scen.id === value)[0]);
    }
  };

  const sendScenario = (e) => {
    if (e.key === 'Enter') {
      dispatch(setInputs({}));
      dispatch(
        addScenario({
          name: newScenario,
          data_source_id: source
        })
      );
    }
  };

  return (
    <>
      <div className={classes.container}>
        <FormControl className={classes.formControl}>
          <InputLabel id="data-source-select-label">Source of data</InputLabel>
          <Select
            className={classes.select}
            id="data-source-select"
            onChange={handleChangeSource}
            value={source}>
            <MenuItem>Choose the data source</MenuItem>
            <Divider />
            {datasources &&
              datasources.map(({ id, diy_file_name }) => (
                <MenuItem key={id} value={id}>
                  {diy_file_name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-helper-label">
            Select scenario
          </InputLabel>
          <Select
            className={classes.select}
            disabled={!source || !scenarios}
            id="select-scenario"
            labelId="select-scenario-label"
            onChange={handleChangeScenario}
            value={scenario}>
            {/* <MenuItem value="">
            <em>Choose the data source</em>
           
          </MenuItem> */}
            <MenuItem>Select scenario</MenuItem>
            <Divider />
            {scenarios &&
              scenarios.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
          </Select>
          {/* <FormHelperText>Some important helper text</FormHelperText> */}
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            disabled={!source}
            id="standard-basic"
            label="Create scenario"
            onChange={(e) => setNewScenario(e.target.value)}
            onKeyPress={sendScenario}
            value={newScenario}
          />
        </FormControl>
        {/* {isLoading && (
          <div className={classes.loader}>
            <CircularProgress size={20} />
          </div>
        )} */}
      </div>
    </>
  );
};

export default SelectComponent;
